import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=39bc89a1&scoped=true"
import script from "./TextLink.vue?vue&type=script&lang=js"
export * from "./TextLink.vue?vue&type=script&lang=js"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=39bc89a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc89a1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftIcon: require('/vercel/path0/components/icons/ArrowLeftIcon.vue').default})
